<!-- eslint-disable max-len -->
<template>
  <div>
    <LoadingSpinner v-if="loading" />
    <div v-if="!loading" class="block relative w-full mt-2">
      <div class="body_inners pl-4 pr-4">
        <div class="block top-block mb-4">
          <h2
            class="
              block
              text-darkgray text-sm
              font-bold
              m-0
              title-block
              text-center
            "
          >
            {{ $t("pages.application_process.application_status") }}
          </h2>
        </div>

        <div
          class="list-items block relative"
          @click="
            $router.push({
              name: 'offerDetails',
              params: { id: details.offer.offer_id },
            })
          "
        >
          <div
            class="
              block
              relative
              walter-block
              bg-white
              rounded-lg
              walter-shadow
              mb-4
            "
          >
            <div class="flex top-block mb-1.5 pt-4 pb-4 pl-4 pr-4">
              <div class="left-block w-2/4 relative">
                <h4 class="block relative text-sm font-bold text-darkblack">
                  {{ details.offer.customer.last_name }}/{{
                    details.offer.customer.first_name
                  }}
                </h4>
                <p
                  class="
                    flex
                    align-center
                    justify-start
                    mb-0
                    mt-1.5
                    text-xs
                    font-medium
                    text-darkgray1
                  "
                >
                  <span class="mr-1">
                    <svg
                      class="w-3 h-3"
                      viewBox="0 0 10 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.99984 0.666992C2.2667 0.666992 0.0415039 2.89219 0.0415039 5.62533C0.0415039 6.85231 0.491635 7.97757 1.23096 8.84277L1.23324 8.84505L1.23494 8.84733C1.23494 8.84733 3.34426 11.2542 4.09522 11.9708C4.59809 12.4502 5.40102 12.4502 5.90389 11.9708C6.75987 11.1544 8.7653 8.84619 8.7653 8.84619L8.76644 8.84448L8.76815 8.84277C9.50813 7.97756 9.95817 6.85231 9.95817 5.62533C9.95817 2.89219 7.73297 0.666992 4.99984 0.666992ZM4.99984 1.54199C7.26004 1.54199 9.08317 3.36513 9.08317 5.62533C9.08317 6.63893 8.71379 7.55983 8.10278 8.27425C8.09881 8.2788 6.04693 10.6255 5.30005 11.3379C5.12684 11.503 4.87227 11.503 4.69906 11.3379C4.07484 10.7423 1.90266 8.28143 1.89632 8.27425L1.89575 8.27368C1.28556 7.55932 0.916504 6.63865 0.916504 5.62533C0.916504 3.36513 2.73964 1.54199 4.99984 1.54199ZM4.99984 3.87533C4.45296 3.87533 3.98741 4.09616 3.68848 4.43245C3.38955 4.76875 3.24984 5.19998 3.24984 5.62533C3.24984 6.05067 3.38955 6.4819 3.68848 6.8182C3.98741 7.15449 4.45296 7.37533 4.99984 7.37533C5.54671 7.37533 6.01227 7.15449 6.3112 6.8182C6.61013 6.4819 6.74984 6.05067 6.74984 5.62533C6.74984 5.19998 6.61013 4.76875 6.3112 4.43245C6.01227 4.09616 5.54671 3.87533 4.99984 3.87533ZM4.99984 4.75033C5.32796 4.75033 5.51866 4.85762 5.65723 5.01351C5.7958 5.1694 5.87484 5.39442 5.87484 5.62533C5.87484 5.85623 5.7958 6.08125 5.65723 6.23714C5.51866 6.39303 5.32796 6.50033 4.99984 6.50033C4.67171 6.50033 4.48102 6.39303 4.34245 6.23714C4.20388 6.08125 4.12484 5.85623 4.12484 5.62533C4.12484 5.39442 4.20388 5.1694 4.34245 5.01351C4.48102 4.85762 4.67171 4.75033 4.99984 4.75033Z"
                        fill="#676666"
                      />
                    </svg>
                  </span>
                  {{ details.offer.location }}
                </p>
              </div>
              <div class="right-block w-2/4 relative">
                <p
                  class="
                    wishlist-icon
                    relative
                    text-smm text-right
                    flex
                    items-center
                    justify-end
                    font-bold
                  "
                >
                  <span class="flex mr-1.5">
                    <svg
                      class="w-3.5 h-3.5"
                      viewBox="0 0 12 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.00016 0.833008C3.32418 0.833008 0.333496 3.8237 0.333496 7.49967C0.333496 11.1757 3.32418 14.1663 7.00016 14.1663C10.6761 14.1663 13.6668 11.1757 13.6668 7.49967C13.6668 3.8237 10.6761 0.833008 7.00016 0.833008ZM7.17334 3.83301C8.49667 3.83301 9.06307 4.39182 9.51774 4.84082C9.71441 5.03482 9.7163 5.35118 9.5223 5.54785C9.32863 5.74452 9.01127 5.74641 8.81527 5.55241C8.40827 5.15074 8.08699 4.83301 7.17399 4.83301C6.37166 4.83301 5.67077 5.37067 5.29443 6.16634H6.8335C7.1095 6.16634 7.3335 6.39001 7.3335 6.66634C7.3335 6.94267 7.1095 7.16634 6.8335 7.16634H5.01904C5.00771 7.27567 5.00016 7.38667 5.00016 7.49967C5.00016 7.61267 5.00771 7.72367 5.01904 7.83301H6.8335C7.1095 7.83301 7.3335 8.05667 7.3335 8.33301C7.3335 8.60934 7.1095 8.83301 6.8335 8.83301H5.29443C5.6711 9.62867 6.37101 10.1663 7.17334 10.1663C8.08634 10.1663 8.40793 9.84861 8.81527 9.44694C9.01127 9.25294 9.32863 9.25516 9.5223 9.4515C9.7163 9.64816 9.71441 9.96486 9.51774 10.1585C9.06307 10.6079 8.49699 11.1663 7.17399 11.1663C5.83132 11.1663 4.68353 10.1967 4.22087 8.83301H3.50016C3.22416 8.83301 3.00016 8.60934 3.00016 8.33301C3.00016 8.05667 3.22416 7.83301 3.50016 7.83301H4.01514C4.00647 7.72301 4.00016 7.61234 4.00016 7.49967C4.00016 7.38701 4.00647 7.27634 4.01514 7.16634H3.50016C3.22416 7.16634 3.00016 6.94267 3.00016 6.66634C3.00016 6.39001 3.22416 6.16634 3.50016 6.16634H4.22021C4.68322 4.80267 5.83101 3.83301 7.17334 3.83301Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                  {{ formatPrice(details.offer.compensation) }} Euro
                </p>
                <p
                  class="
                    flex
                    align-center
                    justify-end
                    mt-1
                    mb-0
                    text-xs
                    font-medium
                    text-darkgray1
                  "
                >
                  {{ $t("pages.common.buttons.dis15") }}:
                  {{
                    formatDate(
                      details.offer.arrival_date,
                      "DD.MM.YYYY",
                      "YYYY-MM-DD"
                    )
                  }}
                </p>
              </div>
            </div>
            <div
              class="
                flex
                items-center
                justify-start
                relative
                pt-3.5
                pb-3.5
                pl-4
                pr-4
                bg-lightgray
                text-darkblack text-xs
                walter-footer
                flex-wrap
              "
            >
              <span class="icon mr-1.5">
                <svg
                  class="w-3 h-3"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 2C4.6875 2 2 4.6875 2 8C2 11.3125 4.6875 14 8 14C11.3125 14 14 11.3125 14 8C14 4.6875 11.3125 2 8 2Z"
                    stroke="#333333"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M8 4V8.5H11"
                    stroke="#333333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <span class="text-xs text-smallxs font-medium">
                {{ $t("pages.application_process.status") }}
              </span>
            </div>
          </div>
        </div>
        <div class="relative block accordian-list-block">
          <div
            class="
              block
              relative
              walter-block
              bg-white
              rounded-lg
              walter-shadow
              mb-4
              tab
            "
          >
            <div class="card tab">
              <input
                id="tab-single1"
                class="card-heading absolute opacity-0"
                type="checkbox"
                name="tabs1"
                checked
              />
              <label
                class="
                  card-heading
                  cursor-pointer
                  flex
                  align-center
                  justify-between
                  mb-0
                  pt-3
                  pb-3
                  pl-4
                  pr-4
                  top-block
                  bg-darkgreen
                  rounded-t-lg
                  tab
                  w-full
                "
                for="tab-single1"
              >
                <span
                  class="block relative text-sm font-bold text-white"
                >
                  {{ $t("pages.application_process.your_document") }}
                </span>
                <span class="flex transform rotate-180 duration-100">
                  <svg
                    class="w-4 h-4"
                    viewBox="0 0 16 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.4957 7.50767C14.3637 7.50455 14.2382 7.44932 14.1467 7.35403L8.00025 1.20754L1.85377 7.35403C1.80716 7.40202 1.7514 7.44018 1.68978 7.46623C1.62817 7.49229 1.56195 7.50572 1.49505 7.50572C1.39554 7.5057 1.2983 7.47598 1.21577 7.42039C1.13325 7.36479 1.06919 7.28583 1.03178 7.19362C0.994383 7.10141 0.985343 7.00014 1.00582 6.90276C1.0263 6.80538 1.07536 6.71633 1.14674 6.647L7.64674 0.146995C7.74051 0.0532622 7.86767 0.000607491 8.00025 0.000607491C8.13284 0.000607491 8.26 0.0532622 8.35377 0.146995L14.8538 6.647C14.9265 6.71678 14.9764 6.80691 14.997 6.90556C15.0176 7.00422 15.0079 7.10679 14.9692 7.19984C14.9305 7.29289 14.8646 7.37207 14.7801 7.427C14.6956 7.48193 14.5964 7.51005 14.4957 7.50767Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </label>
              <div class="tab-content overflow-hidden card-body">
                <div
                  class="block relative pl-4 pr-4 pt-0 pb-0"
                  v-for="docs in documentsList"
                  :key="docs.id"
                >
                  <label
                    class="
                      flex
                      items-center
                      justify-start
                      text-sm
                      font-normal
                      mb-2
                      text-darkgreen
                    "
                  >
                    <span class="flex mr-1.5">
                      <svg
                        class="w-3.5 h-3.5"
                        width="12"
                        height="15"
                        viewBox="0 0 12 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.16675 0.833984C1.33975 0.833984 0.666748 1.50698 0.666748 2.33398V12.6673C0.666748 13.4943 1.33975 14.1673 2.16675 14.1673H9.83341C10.6604 14.1673 11.3334 13.4943 11.3334 12.6673V6.16732H7.50008C6.67308 6.16732 6.00008 5.49432 6.00008 4.66732V0.833984H2.16675ZM7.00008 1.12695V4.66732C7.00008 4.94299 7.22441 5.16732 7.50008 5.16732H11.0404L7.00008 1.12695ZM3.83341 7.83399H8.16675C8.44275 7.83399 8.66675 8.05799 8.66675 8.33399C8.66675 8.60999 8.44275 8.83399 8.16675 8.83399H3.83341C3.55741 8.83399 3.33341 8.60999 3.33341 8.33399C3.33341 8.05799 3.55741 7.83399 3.83341 7.83399ZM3.83016 10.1673H6.82886C7.10486 10.1673 7.32886 10.391 7.32886 10.6673C7.32919 10.9203 7.14122 11.1298 6.89722 11.1628L6.82951 11.1673H3.83081C3.55481 11.1673 3.33081 10.9433 3.33081 10.6673C3.33081 10.4143 3.51845 10.2049 3.76245 10.1719L3.83016 10.1673Z"
                          fill="#63B15B"
                        />
                      </svg>
                    </span>
                    <span class="documentfilecolor">{{
                      docs.description
                    }}</span>
                  
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- temp -->

        <div v-if="contactRecruiter">
          <h4
            class="
              flex
              align-start
              justify-start
              text-center text-darkgray1
              pt-5
              pb-5
              ml-2
              mr-2
            "
          >
            {{ $t("pages.application_process.warning.heading") }}
          </h4>

          <div
            class="
              block
              relative
              pl-4
              pr-4
              pt-2
              pb-5
              info-block
              walter-block
              bg-white
              rounded-lg
              walter-shadow
            "
          >
            <div class="flex align-start justify-start">
              <div class="block relative w-11 h-11 rounded-full">
                <img
                  src="./../../assets/images/fam-profile.png"
                  alt=""
                  class="w-full h-full rounded-full"
                />
              </div>
              <div class="block relative pl-4">
                <label
                  class="
                    flex flex-wrap
                    text-sm text-darkblack
                    font-bold
                    mb-1.5
                    text-darkgray1
                  "
                >
                  Mateusz Walas
                  <span class="font-normal pl-1"> (osoba kontaktowa) </span>
                </label>

                <label
                  class="
                    flex
                    align-center
                    justify-start
                    text-sm
                    font-normal
                    mb-2
                    text-darkgreen
                  "
                >
                  <span class="flex mr-1.5">
                    <svg
                      class="w-4 h-4"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.95717 2.30161L0.978577 2.28823L3.68461 0.955078L6.60533 4.84936L5.26158 6.64114C5.30179 7.31687 5.58834 7.9544 6.067 8.43305C6.54566 8.9117 7.1832 9.19825 7.85892 9.23845L9.65067 7.8947L13.5449 10.8154L12.2229 13.4988L12.2117 13.5214L12.1983 13.5428C12.1278 13.6565 12.0293 13.7502 11.9123 13.8151C11.7953 13.8799 11.6636 13.9138 11.5298 13.9133H10.8315C9.48617 13.9133 8.15396 13.6483 6.911 13.1335C5.66803 12.6186 4.53864 11.864 3.58731 10.9127C2.63599 9.96133 1.88136 8.83194 1.36651 7.58898C0.851656 6.34601 0.586666 5.0138 0.58667 3.66842V2.97014C0.586242 2.83635 0.620065 2.70468 0.684917 2.58766C0.749771 2.47064 0.843495 2.37216 0.95717 2.30161ZM1.58667 3.66842C1.58667 8.76608 5.73392 12.9133 10.8315 12.9133H11.3965L12.2811 11.1176L9.65048 9.14464L8.18589 10.243H8.01923C7.0217 10.2419 6.06534 9.84517 5.35998 9.1398C4.65461 8.43444 4.25785 7.47808 4.25673 6.48055V6.31389L5.35514 4.84933L3.38239 2.21886L1.58667 3.10358V3.66842Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                  71 584 652
                </label>

                <label
                  class="
                    flex
                    align-center
                    justify-start
                    text-sm
                    font-normal
                    mb-2
                    text-darkgreen
                  "
                >
                  <span class="flex mr-1.5">
                    <svg
                      class="w-4 h-4"
                      viewBox="0 0 14 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.4998 0.166992C12.6905 0.166992 13.6665 1.14301 13.6665 2.33366V8.66699C13.6665 9.85764 12.6905 10.8337 11.4998 10.8337H2.49984C1.30919 10.8337 0.33317 9.85764 0.33317 8.66699V2.33366C0.33317 1.14301 1.30919 0.166992 2.49984 0.166992H11.4998ZM11.4998 1.16699H2.49984C1.84982 1.16699 1.33317 1.68364 1.33317 2.33366V2.70215L6.99984 5.7653L12.6665 2.70215V2.33366C12.6665 1.68364 12.1499 1.16699 11.4998 1.16699ZM12.6665 3.83887L7.23747 6.77376C7.16447 6.81319 7.0828 6.83383 6.99984 6.83383C6.91687 6.83383 6.83521 6.81319 6.76221 6.77376L1.33317 3.83887V8.66699C1.33317 9.31701 1.84982 9.83366 2.49984 9.83366H11.4998C12.1499 9.83366 12.6665 9.31701 12.6665 8.66699V3.83887Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                  mateusz.walas@gmail.com
                </label>

                <label
                  class="
                    flex
                    align-center
                    justify-start
                    text-sm
                    font-normal
                    mb-0
                    text-darkgray1
                  "
                >
                  <span class="flex mr-1.5">
                    <svg
                      class="w-4 h-4"
                      viewBox="0 0 14 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.99984 0.833008C10.6758 0.833008 13.6665 3.8237 13.6665 7.49967C13.6665 11.1757 10.6758 14.1663 6.99984 14.1663C3.32386 14.1663 0.33317 11.1757 0.33317 7.49967C0.33317 3.8237 3.32386 0.833008 6.99984 0.833008ZM6.99984 1.83301C3.8643 1.83301 1.33317 4.36414 1.33317 7.49967C1.33317 10.6352 3.8643 13.1663 6.99984 13.1663C10.1354 13.1663 12.6665 10.6352 12.6665 7.49967C12.6665 4.36414 10.1354 1.83301 6.99984 1.83301ZM7.17432 3.49251C7.30681 3.49458 7.43307 3.54916 7.52535 3.64425C7.61764 3.73934 7.6684 3.86718 7.6665 3.99967V7.99967C7.66649 8.13228 7.61381 8.25945 7.52004 8.35321C7.42628 8.44698 7.29911 8.49966 7.1665 8.49967H4.49984C4.43358 8.50061 4.3678 8.48837 4.30631 8.46366C4.24483 8.43896 4.18887 8.40228 4.14169 8.35575C4.0945 8.30923 4.05703 8.2538 4.03146 8.19267C4.00589 8.13154 3.99272 8.06594 3.99272 7.99967C3.99272 7.93341 4.00589 7.86781 4.03146 7.80668C4.05703 7.74555 4.0945 7.69012 4.14169 7.64359C4.18887 7.59707 4.24483 7.56039 4.30631 7.53569C4.3678 7.51098 4.43358 7.49874 4.49984 7.49967H6.6665V3.99967C6.66554 3.93275 6.67803 3.86632 6.70322 3.80431C6.7284 3.7423 6.76578 3.68598 6.81314 3.63869C6.8605 3.59139 6.91687 3.55408 6.97891 3.52898C7.04095 3.50387 7.1074 3.49147 7.17432 3.49251Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                  {{ $t("pages.common.buttons.dis5") }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <!-- temp -->
        <button
          v-if="!contactRecruiter"
          class="
            relative
            flex
            items-center
            justify-center
            flex-nowrap
            text-darkblack text-sm
            walter-footer
            pt-3
            pb-3
            pl-4
            pr-4
            mt-10
            mb-12
            border
            solid
            border-danger
            rounded
            w-full
          "
          @click="revoke"
        >
          <span class="flex mr-2.5">
            <svg
              class="w-4 h-4"
              width="19"
              height="18"
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.243 0.488491C17.045 0.493168 16.8568 0.576021 16.7196 0.718959L9.49987 7.93869L2.28015 0.718959C2.21024 0.646966 2.12659 0.589733 2.03417 0.550649C1.94174 0.511565 1.84241 0.491424 1.74206 0.49142C1.5928 0.491457 1.44694 0.536024 1.32315 0.619421C1.19936 0.702817 1.10327 0.82125 1.04717 0.959566C0.991066 1.09788 0.977506 1.24979 1.00822 1.39586C1.03894 1.54192 1.11254 1.6755 1.2196 1.77951L8.43932 8.99923L1.2196 16.219C1.14762 16.2881 1.09015 16.3708 1.05057 16.4624C1.01098 16.554 0.990067 16.6526 0.989052 16.7524C0.988038 16.8522 1.00694 16.9512 1.04466 17.0435C1.08238 17.1359 1.13815 17.2198 1.20871 17.2904C1.27926 17.361 1.36319 17.4167 1.45557 17.4544C1.54796 17.4922 1.64693 17.5111 1.74671 17.5101C1.84649 17.509 1.94507 17.4881 2.03666 17.4485C2.12826 17.409 2.21104 17.3515 2.28015 17.2795L9.49987 10.0598L16.7196 17.2795C16.7887 17.3515 16.8715 17.409 16.9631 17.4485C17.0547 17.4881 17.1532 17.509 17.253 17.5101C17.3528 17.5111 17.4518 17.4922 17.5442 17.4544C17.6366 17.4167 17.7205 17.361 17.791 17.2904C17.8616 17.2198 17.9174 17.1359 17.9551 17.0435C17.9928 16.9512 18.0117 16.8522 18.0107 16.7524C18.0097 16.6526 17.9888 16.554 17.9492 16.4624C17.9096 16.3708 17.8521 16.2881 17.7801 16.219L10.5604 8.99923L17.7801 1.77951C17.8892 1.67483 17.9641 1.53964 17.995 1.39166C18.0259 1.24367 18.0114 1.08981 17.9533 0.950238C17.8952 0.810664 17.7963 0.691893 17.6696 0.609496C17.5428 0.527098 17.3942 0.48492 17.243 0.488491Z"
                fill="#EE5B64"
              />
            </svg>
          </span>
          <span class="text-sm mr-1 font-semibold text-danger">
            {{ $t("pages.application_process.button") }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner";
import moment from "moment";

export default {
  name: "ApplicationProcess",
  components: { LoadingSpinner },
  data() {
    return {
      contactRecruiter: false,
      documentsList: [],
      readMore: {},
    };
  },
  computed: {
    ...mapGetters("application", {
      details: "selected",
    }),
  },
  created() {
    this.$store.dispatch("user/fetchProfile").then((res) => {
      this.documentsList = res.references;
      //this.$i18n.locale = res.language;
    });
  },
  methods: {
    formatPrice(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    revoke() {
      let current = moment().format('YYYY-MM-DD');
let diff = moment(this.details.offer.arrival_date, 'YYYY-MM-DD').diff(current, 'days');
      // let diff = moment(this.details.offer.arrival_date)
      //   .local()
      //   .diff(moment().local(), "days");

      let daysLeft;

      if (diff === 0) {
        daysLeft = moment(this.details.offer.arrival_date)
          .local()
          .diff(moment().local(), "hours");

        this.contactRecruiter = true;
      } else if (diff > 0 && diff <= 3) {
        daysLeft = diff;
        this.contactRecruiter = true;
      } else {
        this.contactRecruiter = false;

        this.$store.commit("app/showNotification", {
          heading: this.$t("pages.common.buttons.dis6"),
          desc: this.$t("pages.common.buttons.dis7"),
          buttons: {
            okay: {
              text: this.$t("pages.common.buttons.dis6"),
              action: () => {
                this.loading = true;
                this.$store.commit("application/setSelected", {
                  ...this.details,
                  status: "nurse",
                });
                this.$store
                  .dispatch("application/revoke", this.details.id)
                  .then((res) => {
                    if (res == true) {
                      this.loading = false;
                      this.$router.push({ name: "RejectedApplications" });
                    } else {
                      this.$store.commit("app/showNotification", {
                      heading: res.response.data,
                      buttons: {
                        okay: {
                          text: "OK",
                          action: () => {
                            this.loading = false;
                          },
                        },
                      },
                      });
                    }                    
                  });
              },
            },
            cancel: {
              text: this.$t("pages.common.buttons.dis8"),
              action: () => {
                this.loading = false;
              },
            },
          },
        });
      }
    },
    showMore(id) {
      this.$set(this.readMore, id, true);
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
  },
};
</script>

<style scoped>
/* Tab content - closed */
.tab-content {
  max-height: 0;
  -webkit-transition: max-height 0.35s;
  -o-transition: max-height 0.35s;
  transition: max-height 0.35s;
}

.tab input:checked ~ .tab-content {
  max-height: 100vh;
}
.tab input:checked + label {
  display: flex;
}
.tab input:checked + label span.flex.transform.rotate-180 {
  transform: rotate(0deg) !important;
}
.tab label::after {
  float: right;
  right: 0;
  top: 0;
  width: 1.5em;
  height: 1.5em;
  line-height: 1.5;
  font-size: 1.25rem;
  text-align: center;
  -webkit-transition: all 0.35s;
  -o-transition: all 0.35s;
  transition: all 0.35s;
  display: none;
}
.tab input[type="checkbox"] + label::after {
  content: "+";
  font-weight: bold;
  border-width: 1px;
  border-radius: 9999px;
  border-color: #b8c2cc;
}
.tab input[type="radio"] + label::after {
  content: "\25BE";
  font-weight: bold;
  border-width: 1px;
  border-radius: 9999px;
  border-color: #b8c2cc;
  display: none;
}

.tab input[type="checkbox"]:checked + label::after {
  transform: rotate(315deg);
  background-color: #6574cd;
  color: #f8fafc;
}
.tab input[type="radio"]:checked + label::after {
  transform: rotateX(180deg);
  background-color: #6574cd;
  color: #f8fafc;
}
.tab input[type="radio"]:checked + label .iconbox {
  transform: rotate(180deg);
}
</style>
